import { VersioningStatusEnum } from '@/enums/VersioningStatus';
import { Assessment } from './Assessment';
import { Model } from './Model';

export enum EvaluationTypeEnum {
  TEMPLATE = 'TEMPLATE',
  EVALUATION = 'EVALUATION',
}

export default interface Evaluation extends Model {
  type: EvaluationTypeEnum;
  courseLineId?: number;
  coursePathId?: number;
  isDefault: boolean;
  name: string;
  description?: string;
  version: number;
  status: VersioningStatusEnum;
  sourceTemplateId?: number;
  assessments: Assessment[];
}
